import React from "react";

export default function RfpStickySaveBar({
  dirty,
  dirtyCount,
  saving,
  onSave,
  onDiscard,
}) {
  if (!dirty) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-emerald-300 bg-emerald-50/95 px-4 py-3 shadow-lg backdrop-blur dark:border-emerald-800 dark:bg-emerald-950/90">
      <div className="mx-auto flex max-w-none flex-wrap items-center justify-between gap-3">
        <p className="text-sm font-medium text-emerald-900 dark:text-emerald-100">
          {dirtyCount > 0 ? `${dirtyCount} unsaved change(s)` : "Unsaved changes"}
        </p>
        <div className="flex gap-2">
          <button
            type="button"
            disabled={saving}
            className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm dark:border-slate-600"
            onClick={onDiscard}
          >
            Discard
          </button>
          <button
            type="button"
            disabled={saving}
            className="rounded-lg bg-emerald-700 px-4 py-1.5 text-sm font-medium text-white disabled:opacity-60"
            onClick={onSave}
          >
            {saving ? "Saving…" : "Save changes"}
          </button>
        </div>
      </div>
    </div>
  );
}
